<script setup lang="ts">
  import { MpBox, MpText } from '@borg/ui';
  import { wait } from '@borg/utils';

  const props = withDefaults(
    defineProps<{
      isSending?: boolean;
    }>(),
    {
      isSending: false,
    },
  );
  const forceDisplay = ref(false);
  const display = computed(() => props.isSending || forceDisplay.value);

  watch(
    () => props.isSending,
    async (value) => {
      if (value) {
        forceDisplay.value = true;
        await wait(2000);
        forceDisplay.value = false;
      }
    },
  );
</script>

<template>
  <Transition>
    <div v-show="display">
      <MpBox
        surface="10"
        class="sending-job-application"
      >
        <div class="sending-job-application__inner">
          <div class="plane">
            <Illustration
              image="application-sending"
              height="250"
            />
          </div>
          <MpText as="h3">
            {{ $t('JOB_APPLICATION_OVERVIEW_PAGE.SENDING_APPLICATION_TEXT') }}
          </MpText>
        </div>
      </MpBox>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
  .sending-job-application {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;

    &__inner {
      display: flex;
      flex-direction: column;
      min-height: 200px;
      text-align: center;
    }
  }

  $transformStart: translate(-30%, 10%) scale(1) rotateZ(10deg);
  $fx: 60%;
  $fy: -50%;

  .plane {
    margin-bottom: 2em;
    animation-name: fly;
    animation-duration: 2200ms;
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-delay: 200ms;
    transform: $transformStart;
    opacity: 0;
  }

  @keyframes fly {
    5% {
      transform: $transformStart;
      opacity: 1;
    }
    70% {
      opacity: 0.75;
    }
    100% {
      transform: translate($fx, $fy) scale(0.1) rotateZ(-10deg);
      opacity: 0;
    }
  }

  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>
